import React from 'react';
import { useCounter } from '../useCounter';

export const StartCounter = ({ expired, hidden, countFrom }) => {
  const { count } = useCounter({ expired, countFrom });

  return (
    <div className={`ct-screen-record-counter ${hidden ? 'ct-screen-record-counter--hidden' : ''}`}>
      <svg className="ct-screen-record-counter__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <g className="ct-screen-record-counter__circle">
          <circle className="ct-screen-record-counter__path-elapsed" cx="50" cy="50" r="45"></circle>
        </g>
      </svg>
      <span className="ct-screen-record-counter__label">{count}</span>
    </div>
  );
};
